// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__content--U5bl0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__topLine--j9dv9 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listBox--Zg2Uk {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 4px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listTools--zOTIj {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listTools--zOTIj .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__toolsLabel--uDPbD {
  flex: 1;
  color: rgba(0, 0, 0, 0.55);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listContent--KN9NQ {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__table--HtdwB {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__table--HtdwB .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__th--cwdq8 {
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fafafa;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.55);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__table--HtdwB .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__td--xgYqw {
  text-align: center;
  padding: 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2EntitySizeLine/Mc2EntitySizeLineModal.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AAGA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AADF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAFF;AAFA;EAOI,OAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAMA;EACE,OAAA;EACA,cAAA;AAJF;AAOA;EACE,aAAA;EACA,wCAAA;AALF;AAGA;EAKI,kBAAA;EACA,yCAAA;EACA,4CAAA;EACA,mBAAA;EAEA,gBAAA;EACA,0BAAA;EACA,uBAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AAXA;EAqBI,kBAAA;EACA,iBAAA;AAPJ","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 100%;\n}\n\n.topLine {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n}\n\n.listBox {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding-top: 4px;\n}\n\n.listTools {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n\n  .toolsLabel {\n    flex: 1;\n    color: rgba(0, 0, 0, 0.55);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 160%;\n  }\n}\n\n.listContent {\n  flex: 1;\n  overflow: auto;\n}\n\n.table {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto; // 1fr 110px 1fr 80px;\n\n  .th {\n    padding: 16px 24px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    background: #fafafa;\n\n    overflow: hidden;\n    color: rgba(0, 0, 0, 0.55);\n    text-overflow: ellipsis;\n\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n  }\n  .td {\n    text-align: center;\n    padding: 5px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__content--U5bl0`,
	"topLine": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__topLine--j9dv9`,
	"listBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listBox--Zg2Uk`,
	"listTools": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listTools--zOTIj`,
	"toolsLabel": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__toolsLabel--uDPbD`,
	"listContent": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__listContent--KN9NQ`,
	"table": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__table--HtdwB`,
	"th": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__th--cwdq8`,
	"td": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntitySizeLine-Mc2EntitySizeLineModal-module__td--xgYqw`
};
export default ___CSS_LOADER_EXPORT___;
